<template>
  <div class="com-game-list">
    <div class="game-box">
      <div class="game-item" v-for="game, index in show_all_game_card ? gameCardList : gameCardList.slice(0, 3)" :key="index">
        <img :src="game.image" class="game-img">
        <div class="game-info-box">
          <p class="game-name">{{game.name}}</p>
          <div class="game-info-bottom">
            <div class="game-price" :class="{'history': false}">
              <svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.51771 2.89306C8.51771 2.79323 8.44539 2.67106 8.35661 2.62149L4.62563 0.522195C4.53685 0.472628 4.46382 0.432136 4.46239 0.432834C4.46096 0.433532 4.38793 0.39304 4.29914 0.343473L3.81514 0.0711999C3.72636 0.0216323 3.65404 0.0621241 3.65404 0.161957V4.02265C3.65404 4.12248 3.7371 4.20346 3.83948 4.20346H5.08887C5.19197 4.20346 5.27503 4.12248 5.27503 4.02265V2.98312C5.27503 2.88329 5.34734 2.8428 5.43612 2.89236L6.73491 3.62401C6.8237 3.67358 6.89601 3.79575 6.89601 3.89558V8.00481C6.89601 8.10464 6.96832 8.14513 7.05711 8.09557L8.35661 7.36462C8.44539 7.31505 8.51771 7.19288 8.51771 7.09304V2.89306ZM3.90148 5.79363C3.79905 5.79363 3.71596 5.87453 3.71596 5.97427L3.71811 7.01211C3.71811 7.11185 3.64577 7.1523 3.55695 7.10278L2.25686 6.37253C2.16876 6.32301 2.09641 6.20095 2.09641 6.10121V1.9952C2.09641 1.89546 2.02407 1.85501 1.93525 1.90453L0.635166 2.63478C0.546345 2.6843 0.473999 2.80636 0.473999 2.9061V7.10208C0.473999 7.20182 0.546345 7.32388 0.635166 7.3734L3.27472 8.85762C3.36354 8.90714 3.43589 8.94829 3.43589 8.94899C3.43589 8.94968 3.50752 8.99084 3.59634 9.04036L5.17649 9.92893C5.26532 9.97845 5.33766 9.938 5.33766 9.83826V5.97427C5.33695 5.87453 5.25385 5.79363 5.15142 5.79363H3.90148Z" fill="#14191E"/>
              </svg>
              <p class="free" v-if="game.is_free">免费</p>
              <p class="current-price" v-if="!game.is_free && game.price">¥{{game.price && game.price.current}}</p>
              <p class="origin-price"  v-if="game.price && game.price.discount != 0 && !game.is_free">¥{{game.price && game.price.initial}}</p>
            </div>
            <div class="rich-label">
              <div class="label-wrapper">
                <p v-for="label in game.rich_tags" v-html="getDomByJson(label)"></p>
              </div>
            </div>
          </div>
        </div>
        <div class="follow-btn" @click="openInAppGame(game)">关注</div>
      </div>
    </div>
    <div class="show-more-games" v-if="gameCardList.length > 3 && !show_all_game_card" @click="showAllGameCard">
        <p class="text">查看全部{{gameCardList.length}}款</p>
        <svg width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M1.16669 2.33325H7.83335L4.50002 6.33325L1.16669 2.33325Z" fill="#8C9196"/>
        </svg>
    </div>
  </div>
</template>

<script>
import { getUrlParam } from '_lib/utils'
import { CLIENT_TYPE } from '../assets/js/global'
export default {
  props: {
    gameCardList: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      show_all_game_card: false
    }
  },
  methods: {
    showAllGameCard () {
      this.show_all_game_card = true
    },
    getDomByJson (config) {
      console.log(utils.getDomByJson(config, 'text'));
      return utils.getDomByJson(config, 'text')
    },
    // 在app打开游戏商品
    openInAppGame (game) {
      var host = (window.location.host.startsWith('accoriapi')  || getUrlParam('client_type') == 'acc_mobile') ? 'acc.xiaoheihe.cn' : CLIENT_TYPE == 'maxjia' ? 'wx.maxjia.com' : 'c.xiaoheihe.cn'
      if (/QQ/i.test(this.ua) || /Weibo/i.test(this.ua) || /Android/i.test(this.ua) ) {
        window.location = `/open_inapp/#heybox://opengame?appid=${game.steam_appid}&game_type=${game.game_type}&concept=1`
      } else {
        let url = 'https://' +  host + `/game/share_game_detail?appid=${game.steam_appid}&game_type=${game.game_type}`
        window.location = url
      }
    }, 
  }
}
</script>

<style lang="less">
.com-game-list {
  padding: 0 14px;
  .game-box {
    margin-top: 12px;
    width: 100%;
    padding: 10px;
    background: #FAFBFC;
    border: 1px solid #F3F4F5;
    border-radius: 3px;
    .game-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 12px;
      &:nth-of-type(1) {
        margin-top: 0;
      }
      .game-img {
        height: 42px;
        width: 84px;
        border-radius: 2px;
      }
      .game-info-box {
        flex: 1;
        width: 0;
        .game-name {
          margin-left: 10px;
          font-size: 13px;
          font-weight: 500;
          line-height: 18px;
          color: #14191E;
        }
        .game-info-bottom {
          display: flex;
          align-items: center;
          .game-price {
            position: relative;
            display: inline-flex;
            align-items: center;
            margin-top: 5px;
            margin-left: 10px;
            padding: 3px 4px;
            border-radius: 2px;
            background: #F3F4F5;
            &.history {
              padding: 3px 30px 3px 4px;
              &::after {
                content: '史低';
                position: absolute;
                right: 0;
                top: 0;              
                width: 26px;
                font-size: 10px;
                line-height: 20px;
                text-align: center;
                color: #FFFFFF;
                background: #32B846;
                border-radius: 0 2px 2px 0;
              }
            }
            .platform {
              width: 8px;
              height: 10px;
            }
            .free {
              margin-left: 4px;
              font-size: 12px;
              font-weight: 700;
              line-height: 14px;
              color: #14191E;
            }
            .current-price {
              margin-left: 4px;
              font-size: 12px;
              font-weight: 700;
              line-height: 14px;
              color: #14191E;
            }
            .origin-price {
              margin-left: 4px;
              font-size: 10px;
              line-height: 11px;
              color: #8C9196;
              text-decoration-line: line-through;
            }
          }
          .rich-label {
            position: relative;
            height: 14px;
            margin-left: 5px;
            .label-wrapper {
              position: absolute;
              top: 0;
              left: 0;
            }
          }
        }
        
      }
      .follow-btn {
        padding: 2px 10px;
        font-size: 11px;
        font-weight: 500;
        line-height: 16px;
        color: #FFFFFF;
        background: #14191E;
        border-radius: 2px;
      }
    }
  }
  .show-more-games {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 30px;
    margin-top: -10px;
    background: #F7F8F9;
    border-radius: 0 0 3px 3px;
    .text {
      font-size: 12px;
      line-height: 16px;
      color: #8C9196;
    }
    svg {
      margin-left: 4px;
    }
  }
}
</style>